export const VIEWPORT_REFIT_SCALE_EPSILON = 0.001
export const VIEWPORT_REFIT_SIZE_EPSILON_PX = 1

export function shouldRefitToViewportOnResize({
  newMinScale,
  previousMinScale,
  currentScale,
  wrapperWidth,
  wrapperHeight,
  previousWrapperWidth,
  previousWrapperHeight,
}: {
  newMinScale: number
  previousMinScale: number
  currentScale: number
  wrapperWidth: number
  wrapperHeight: number
  previousWrapperWidth: number
  previousWrapperHeight: number
}): boolean {
  if (newMinScale <= 0) return false
  if (previousWrapperWidth === 0 && previousWrapperHeight === 0) return false

  const sizeUnchanged =
    Math.abs(wrapperWidth - previousWrapperWidth) <
      VIEWPORT_REFIT_SIZE_EPSILON_PX &&
    Math.abs(wrapperHeight - previousWrapperHeight) <
      VIEWPORT_REFIT_SIZE_EPSILON_PX
  if (sizeUnchanged) return false

  const atMin =
    previousMinScale > 0 &&
    Math.abs(currentScale - previousMinScale) < VIEWPORT_REFIT_SCALE_EPSILON
  if (atMin) return true
  return currentScale < newMinScale - VIEWPORT_REFIT_SCALE_EPSILON
}
